import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 1440 1024"
}
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<path fill=\"#fff\" d=\"M0 0h1440v1024H0z\"></path><path fill=\"#6A6D9E\" d=\"M-1.5 414.5V-3h636l435 275.5z\"></path><path fill=\"#FCC16F\" d=\"M1 1018V42c219.066 40.48 303.476 242.376 811.447 242.376 157.13 0 469.783 121.271 627.553 121.438V1018z\"></path><path fill=\"#FF6801\" d=\"m-70.174 1237.67-53.222-1003.447c55.09-25.314 146.946-66.745 367.042 16.176 186.618 70.309 496.476 205.14 744.348 340.497C1223.69 719.602 1501.99 1087.79 1725.6 1142.43z\"></path><path fill=\"#16194F\" d=\"M-98 1024V290.001C-42.565 273.667-3.886 292 208 361c179.656 58.504 324.073 303.677 560.512 412C993.333 876 1454.19 975.5 1671 1024z\"></path><path fill=\"#1C19B3\" d=\"M1440 515V0H419c19.235 24.667 111.07 113.6 324.526 272S1296.78 500 1440 515\"></path>", 6)
const _hoisted_8 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_8]))
}
export default { render: render }